<template>
  
    <el-container>
     
      <el-main>
       <h1>快捷键</h1>
       <table>
<thead>
<tr>
<th>功能</th>
<th>快捷键</th>
</tr>
</thead>
<tbody>

<tr>
<td>新建思维导图</td>
<td>Ctrl/Cmd+P</td>
</tr>
<tr>
<td>新建子节点</td>
<td>Tab</td>
</tr>
<tr>
<td>新建兄弟节点</td>
<td>enter</td>
</tr>
<tr>
<td>删除</td>
<td>Delete/Backspace</td>
</tr>
<tr>
<td>编辑节点</td>
<td>空格键/双击节点</td>
</tr>
<tr>
<td>撤销</td>
<td>Ctrl/Cmd+Z</td>
</tr>
<tr>
<td>恢复</td>
<td>Ctrl/Cmd+Y</td>
</tr>
<tr>
<td>退出编辑节点</td>
<td>Tab</td>
</tr>
<tr>
<td>展开节点</td>
<td>Ctrl/Cmd + /</td>
</tr>
<tr>
<td>收缩节点</td>
<td>Ctrl/Cmd + /</td>
</tr>
<tr>
<td>移动节点</td>
<td>拖动节点至其他节点</td>
</tr>
<tr>
<td>切换节点</td>
<td>Up/down/left/right</td>
</tr>
<tr>
<td>放大缩小画布</td>
<td>Ctrl/Cmd + 鼠标滚轮</td>
</tr>
<tr>
<td>居中思维导图</td>
<td>Ctrl/Cmd + E</td>
</tr>
<tr>
<td>改变节点布局方式</td>
<td>选中节点,Ctrl/Cmd + U / D / L / R / M / J / K / T / Q</td>
</tr>
<tr>
<td>删除归纳、外框或者关联线</td>
<td>Delete/Backspace</td>
</tr>
</tbody>
</table>
      
      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'shortcutPage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
